import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { urlServer } from '../../config'
import { IMaps, IPlacesID, ISensorsId, IMap } from '../interface'

type TQuery = {
    token: string | null
    placeId?: string
}

export const addressApi = createApi({
    reducerPath: 'addressApi',

    baseQuery: fetchBaseQuery({
        baseUrl: urlServer,
    }),

    endpoints: (build) => ({
        getPlaces: build.mutation<IPlacesID, TQuery>({
            query: ({ token, placeId }) => ({
                url: `/place/tree/${placeId}`,
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
            }),
        }),
        getTree: build.mutation<IPlacesID, TQuery>({
            query: ({ token }) => ({
                url: `/place/tree`,
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
            }),
        }),
        // 👉 Изменено: перевели на query для автоматического кэширования в Redux
        getMap: build.query<IMaps, { token: string | null; total: number }>({
            query: ({ token, total }) => ({
                url: `/dashboard`,
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
            }),
            transformResponse: (response: IMaps) => {
                const now = new Date();
                const currentDayString = now.toDateString();
                const oneDayInMs = 24 * 60 * 60 * 1000;

                let onlineCount = 0;
                let warningCount = 0;
                let offlineCount = 0;

                const transformedGateways = response.gateways.map((gateway: IMap) => {
                    if (!gateway.last_seen_at) {
                        offlineCount++;
                        return {
                            ...gateway,
                            status: 'offline' as const,
                            lastSeen: null
                        };
                    }

                    const lastSeenDate = new Date(gateway.last_seen_at);
                    const diffInMs = now.getTime() - lastSeenDate.getTime();
                    
                    let status: 'online' | 'warning' | 'offline' = 'offline';

                    if (lastSeenDate.toDateString() === currentDayString) {
                        status = 'online';
                        onlineCount++;
                    } else if (diffInMs < oneDayInMs) {
                        status = 'warning';
                        warningCount++;
                    } else {
                        status = 'offline';
                        offlineCount++;
                    }

                    return {
                        ...gateway,
                        status,
                        lastSeen: gateway.last_seen_at
                    };
                });

                return {
                    ...response,
                    gateways: transformedGateways,
                    stats: {
                        onlineCount,
                        warningCount,
                        offlineCount
                    }
                };
            }
        }), 
        getSensorsFlat: build.mutation<ISensorsId, TQuery>({
            query: ({ token, placeId }) => ({
                url: `/object/${placeId}`,
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
            }),
        }),
    })
})

// 👉 Изменено: теперь экспортируется useGetMapQuery вместо useGetMapMutation
export const { 
    useGetPlacesMutation, 
    useGetMapQuery, 
    useGetSensorsFlatMutation, 
    useGetTreeMutation 
} = addressApi;
